import React from 'react';

import { useHasQuickStart } from '@components/routes/entitlements';
import { GetStarted, InlineGetStarted } from '@components/routes/pages';
import { entitled } from '@components/routes/routeEntitlement';

import { useIsInlineGetStartedEnabled } from './inlineGetStartedFlag';

/**
 * `/getStarted` is the inline setup page for workspaces with the inline Get started flag on.
 * Everyone else keeps the legacy quick start page, which only some plans have.
 */
export const GetStartedRoute = () => {
  const isInlineGetStartedEnabled = useIsInlineGetStartedEnabled();

  return isInlineGetStartedEnabled ? (
    <InlineGetStarted />
  ) : (
    entitled(useHasQuickStart, <GetStarted />)
  );
};
